import NewEventModalView from './newEventModal.html';
import TaskModalView from './taskModal.html';
import NewReservationModalView from './newReservationModal.html';
import TemplateModalView from '../../events/templateModal.html';

import moment from "moment";
import allLocales from "fullcalendar/dist/locale-all";

import toastr from 'toastr';

import _ from 'lodash';

angular.module("calendar", [])

.controller("CalendarCtrl", ['$state', '$timeout', '$stateParams', 'generateDocumentService', 'Restangular', '$scope', 'LoginService', '$rootScope', '$controller', 'uiCalendarConfig', '$http', '$filter', '$compile', 'i18nService', 'modalService', '$uibModal', 'logService',
        function ($state, $timeout, $stateParams, generateDocumentService, Restangular, $scope, LoginService, $rootScope, $controller, uiCalendarConfig, $http, $filter, $compile, i18nService, modalService, $uibModal, logService) {
   
    $scope.optionsUsers = {
        user_id: parseInt(localStorage.getItem("userId")),
        start: null,
        end: null,
        location_id: null,
        event_id: null
    };

    var currentState = $state.current.name; 
    $scope.allowChangeUsersDashboard = LoginService.permissionExist("USER_COMBO_CALENDAR") && currentState != "locations.edit";
    $scope.allorPrintSchedule = LoginService.permissionExist("EVENTS_PROGRAM_ACT_USER_PRINT");

    Restangular.one('Companies', $rootScope.company_id).get().then(function (results) {
        $scope.base_url_api = results.base_url;
    }, function (response) {
        $scope.errorMessage = response.message;
    });

    if ($scope.allowChangeUsersDashboard) {
        Restangular.all('Users').getList().then(function (results) {
            $scope.selectUsers = results;
        });
    }

    /*
    * Datepicker pequeño
    */
    $scope.dt = new Date();

    $scope.calendar = null;

    $scope.today = function () {
        $scope.dt = new Date();
    };

    $scope.inlineOptions = {                      
        showWeeks: false,            
        startingDay: 1,
        maxMode: 'year',
        locale: 'es'
    };       

    $scope.toggleMin = function () {
        $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date();
        $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
    };
                
    $scope.selectDate = function (dt) {
        $scope.dt = dt;
        var calendar = uiCalendarConfig.calendars['myCalendar'];
        calendar.fullCalendar('gotoDate', dt);
        calendar.fullCalendar('select', dt);

    };

    $scope.selectUser = function () {
        var calendar = uiCalendarConfig.calendars['myCalendar'];
        calendar.fullCalendar('refetchEvents');
    };

    /*
    * Calendario
    */
    $scope.events = [];
    $scope.checkUserTasks = false;
    $scope.checkOtherTasks = false;
    $scope.checkEventTasks = false;
    $scope.checkEvents = false;
    $scope.checkUserEvents = false;
    $scope.checkOtherEvents = false;
    $scope.checkEventProgramActs = false;
    $scope.checkBirthdays = false;
    $scope.checkActs = false;
    $scope.checkLocationPending = false;
    $scope.checkLocationConfirmed = false;
    $scope.checkLocationCancelled = false;
    $scope.checkLocationRejected = false;
    $scope.checkLocationId = null;
    $scope.checkLocationsChecked = [];

    $scope.loadedSections = 0;
    $scope.loadedSectionsTotal = 0;

    $scope.locations = [];

    //Guardamos los checks en localstorage
    $scope.calendarOptions = function (options, event_id, location_id, nameCalendar) {
        $scope.optionsUsers.location_id = location_id;
        $scope.nameCalendar = nameCalendar;
        $scope.calendarGroups = options;
        $scope.optionsUsers.event_id = event_id;
        $scope.loadedSectionsTotal = options.length;

        if ($scope.calendarGroups.indexOf('USER-TASKS') >= 0) {
            if (localStorage.getItem("checkUserTasks") != null) {
                $scope.checkUserTasks = JSON.parse(localStorage.getItem("checkUserTasks"));
            } else {
                $scope.checkUserTasks = true;
                localStorage.setItem("checkUserTasks", "true");
            }
        }

        if ($scope.calendarGroups.indexOf('OTHER-TASKS') >= 0) {
            if (localStorage.getItem("checkOtherTasks") != null) {
                $scope.checkOtherTasks = JSON.parse(localStorage.getItem("checkOtherTasks"));
            } else {
                $scope.checkOtherTasks = true;
                localStorage.setItem("checkOtherTasks", "true");
            }
        }

        if ($scope.calendarGroups.indexOf('EVENT-TASKS') >= 0) {
            if (localStorage.getItem("checkEventTasks") != null) {
                $scope.checkEventTasks = JSON.parse(localStorage.getItem("checkEventTasks"));
            } else {
                $scope.checkEventTasks = true;
                localStorage.setItem("checkEventTasks", "true");
            }
        }

        if ($scope.calendarGroups.indexOf('EVENTS') >= 0) {
            if (localStorage.getItem("checkEvents") != null) {
                $scope.checkEvents = JSON.parse(localStorage.getItem("checkEvents"));
            } else {
                $scope.checkEvents = true;
                localStorage.setItem("checkEvents", "true");
            }
        }

        if ($scope.calendarGroups.indexOf('USER-EVENTS') >= 0) {
            if (localStorage.getItem("checkUserEvents") != null) {
                $scope.checkUserEvents = JSON.parse(localStorage.getItem("checkUserEvents"));
            } else {
                $scope.checkUserEvents = true;
                localStorage.setItem("checkUserEvents", "true");
            }
        }

        if ($scope.calendarGroups.indexOf('OTHER-EVENTS') >= 0) {
            if (localStorage.getItem("checkOtherEvents") != null) {
                $scope.checkOtherEvents = JSON.parse(localStorage.getItem("checkOtherEvents"));
            } else {
                $scope.checkOtherEvents = true;
                localStorage.setItem("checkOtherEvents", "true");
            }
        }

        if ($scope.calendarGroups.indexOf('EVENT-PROGRAM-ACTS') >= 0) {
            if (localStorage.getItem("checkEventProgramActs") != null) {
                $scope.checkEventProgramActs = JSON.parse(localStorage.getItem("checkEventProgramActs"));
            } else {
                $scope.checkEventProgramActs = true;
                localStorage.setItem("checkEventProgramActs", "true");
            }
        }

        if ($scope.calendarGroups.indexOf('BIRTHDAYS') >= 0) {
            if (localStorage.getItem("checkBirthdays") != null) {
                $scope.checkBirthdays = JSON.parse(localStorage.getItem("checkBirthdays"));
            } else {
                $scope.checkBirthdays = false;
                localStorage.setItem("checkBirthdays", "false");
            }
        }

        if ($scope.calendarGroups.indexOf('EVENT-PROGRAM-ACTS-USERS') >= 0) {
            if (localStorage.getItem("checkActs") != null) {
                $scope.checkActs = JSON.parse(localStorage.getItem("checkActs"));
            } else {
                $scope.checkActs = false;
                localStorage.setItem("checkActs", "false");
            }
        }

        if ($scope.calendarGroups.indexOf('LOCATION_PENDING') >= 0) {
            if (localStorage.getItem("checkLocationPending") != null) {
                $scope.checkLocationPending = JSON.parse(localStorage.getItem("checkLocationPending"));
            } else {
                $scope.checkLocationPending = true;
                localStorage.setItem("checkLocationPending", "true");
            }
        }

        if ($scope.calendarGroups.indexOf('LOCATION_CONFIRMED') >= 0) {
            if (localStorage.getItem("checkLocationConfirmed") != null) {
                $scope.checkLocationConfirmed = JSON.parse(localStorage.getItem("checkLocationConfirmed"));
            } else {
                $scope.checkLocationConfirmed = true;
                localStorage.setItem("checkLocationConfirmed", "true");
            }
        }

        if ($scope.calendarGroups.indexOf('LOCATION_REJECTED') >= 0) {
            if (localStorage.getItem("checkLocationRejected") != null) {
                $scope.checkLocationRejected = JSON.parse(localStorage.getItem("checkLocationRejected"));
            } else {
                $scope.checkLocationRejected = true;
                localStorage.setItem("checkLocationRejected", "true");
            }
        }

        if ($scope.calendarGroups.indexOf('LOCATION_CANCELLED') >= 0) {
            if (localStorage.getItem("checkLocationCancelled") != null) {
                $scope.checkLocationCancelled = JSON.parse(localStorage.getItem("checkLocationCancelled"));
            } else {
                $scope.checkLocationCancelled = true;
                localStorage.setItem("checkLocationCancelled", "true");
            }
        }

        if ($scope.calendarGroups.indexOf('LOCATIONS') >= 0) {
            Restangular.all('Locations').getList(options).then(function (result) {
                $scope.locations = result;
                var cont = 1;
                angular.forEach($scope.locations, function (row) {
                    let checked = true;
                    if (localStorage.getItem("checkLocationsChecked" + row.id) != null) checked = JSON.parse(localStorage.getItem("checkLocationsChecked" + row.id));
                    $scope.checkLocationsChecked[row.id] = { checked: checked };
                    /*if (cont == $scope.locations.length) {
                        $scope.locationsCheked(null, $scope.checkLocationsChecked);
                    }
                    cont++;*/
                });
                $scope.loadedSectionsTotal = $scope.locations.length;
                //$scope.refetchEvents();
            });
            
        }
    };

    $scope.printPage = function () {
        window.print();
    };


    $scope.getCalendarEvents = function (view) {
        $scope.events = [];
        $scope.loadedSections = 0;

        //obtenemos referencia al calendario
        var calendar = view.calendar;
        let start = view.start;
        let end = view.end;

        let options: any = {
            start: start.format('YYYY-MM-DD'),
            end: end.format('YYYY-MM-DD'),
            userId: $scope.optionsUsers.user_id
        };
        //guardamos el start y end por si cambian el combo
        $scope.optionsUsers.start = start;
        $scope.optionsUsers.end = end;

            
        if ($scope.calendarGroups.indexOf('USER-TASKS') >= 0) {                

            if ($scope.checkUserTasks) {
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/CalendarsEvents/UserTasks',
                    params: options
                }).then(function (results, status, headers, config) {
                    angular.forEach(results.data.rows, function (calendarRange) {
                        // logService.debug(calendarRange);

                        $scope.events.push({
                            task_id: calendarRange.task_id,
                            event_id: calendarRange.event_id,
                            title: calendarRange.title,
                            start: moment.utc(calendarRange.date_from).toDate(),
                            end: moment.utc(calendarRange.date_to).toDate(),
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#f7a54a",
                            textColor: "white",
                            borderColor: "#f7a54a",
                            eventName: (calendarRange.type == "UserTasks" ? calendarRange.event_name : ""),
                            eventType: "userTasks",
                            entityType: (calendarRange.type == "UserTasksNew" ? calendarRange.entity_type : ""),
                            entityTypeId: (calendarRange.type == "UserTasksNew" ? calendarRange.entity_type_id : "")
                        });

                    });          
                    calendar.refetchEvents();
                });
            } else {
                calendar.refetchEvents();
            }
        }

        if ($scope.calendarGroups.indexOf('OTHER-TASKS') >= 0) {

            if ($scope.checkOtherTasks) {
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/CalendarsEvents/OtherTasks',
                    params: options
                }).then(function (results, status, headers, config) {
                    angular.forEach(results.data.rows, function (calendarRange) {

                        $scope.events.push({
                            task_id: calendarRange.task_id,
                            event_id: calendarRange.event_id,
                            title: calendarRange.title,
                            //start: new Date(moment.utc(calendarRange.date_from)),
                            //end: new Date(moment.utc(calendarRange.date_to)),
                            start: new Date(calendarRange.date_from),
                            end: calendarRange.all_day ? moment(new Date(calendarRange.date_to).setDate(new Date(calendarRange.date_to).getDate() + 1)) : new Date(calendarRange.date_to),
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#cc99FF",
                            textColor: "white",
                            borderColor: "#cc99FF",
                            eventType: "otherTasks",
                            eventName: calendarRange.event_name
                        });
                    });
                    calendar.refetchEvents();
                });
            } else {
                calendar.refetchEvents();
            }
        }

        if ($scope.calendarGroups.indexOf('EVENT-TASKS') >= 0) {
            if ($scope.checkEventTasks) {
                options.event_id = $scope.optionsUsers.event_id;
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/CalendarsEvents/EventTasks',
                    params: options
                }).then(function (results, status, headers, config) {
                    angular.forEach(results.data.rows, function (calendarRange) {
                        $scope.events.push({
                            task_id: calendarRange.task_id,
                            event_id: calendarRange.event_id,
                            title: calendarRange.title,
                            //start: new Date(moment.utc(calendarRange.date_from)),
                            //end: new Date(moment.utc(calendarRange.date_to)),
                            start: new Date(calendarRange.date_from),
                            end: calendarRange.all_day ? moment(new Date(calendarRange.date_to).setDate(new Date(calendarRange.date_to).getDate() + 1)) : new Date(calendarRange.date_to),
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#f7a54a",
                            textColor: "white",
                            borderColor: "#f7a54a",
                            eventType: "eventTasks",
                            eventName: calendarRange.event_name
                        });
                    });                       
                    calendar.refetchEvents();
                });
            } else {
                calendar.refetchEvents();
            }
        }

        if ($scope.calendarGroups.indexOf('USER-EVENTS') >= 0) {
            if ($scope.checkUserEvents) {                    
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/CalendarsEvents/UserEvents',
                    params: options
                }).then(function (results, status, headers, config) {
                    angular.forEach(results.data.rows, function (calendarRange) {
                        $scope.events.push({
                            task_id: null,
                            event_id: calendarRange.event_id,
                            title: calendarRange.title,
                            start: moment.utc(calendarRange.date_from).toDate(),
                            end: moment.utc(calendarRange.date_to).toDate(),
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#ff3399",
                            textColor: "white",
                            borderColor: "#ff3399",
                            eventName: (typeof (calendarRange.title) !== "undefined" ? calendarRange.title : ""),
                            eventType: "userEvents",
                            events_guests: calendarRange.events_guests
                        });
                    });
                    calendar.refetchEvents();
                });
            } else {
                calendar.refetchEvents();
            }
        }

        if ($scope.calendarGroups.indexOf('EVENTS') >= 0) {

            if ($scope.checkEvents) {
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/CalendarsEvents/Events',
                    params: options
                }).then(function (results, status, headers, config) {
                    angular.forEach(results.data.rows, function (calendarRange) {
                        $scope.events.push({
                            task_id: null,
                            event_id: calendarRange.event_id,
                            title: calendarRange.title,
                            //start: new Date(moment.utc(calendarRange.date_from)),
                            //end: new Date(moment.utc(calendarRange.date_to)),
                            start: new Date(calendarRange.date_from),
                            end: calendarRange.all_day ? moment(new Date(calendarRange.date_to).setDate(new Date(calendarRange.date_to).getDate() + 1)) : new Date(calendarRange.date_to),
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#460505",
                            textColor: "white",
                            borderColor: "#460505",
                            eventName: (typeof (calendarRange.title) !== "undefined" ? calendarRange.title : ""),
                            eventType: "events"
                        });                        
                    });
                    calendar.refetchEvents();
                });
            } else {
                calendar.refetchEvents();
            }
        }

        if ($scope.calendarGroups.indexOf('OTHER-EVENTS') >= 0) {
            if ($scope.checkOtherEvents) {
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/CalendarsEvents/OtherEvents',
                    params: options
                }).then(function (results, status, headers, config) {
                    angular.forEach(results.data.rows, function (calendarRange) {
                        $scope.events.push({
                            task_id: null,
                            event_id: calendarRange.event_id,
                            title: calendarRange.title,
                            start: new Date(calendarRange.date_from),
                            end: calendarRange.all_day ? moment(new Date(calendarRange.date_to).setDate(new Date(calendarRange.date_to).getDate() + 1)) : new Date(calendarRange.date_to) ,
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#23c6c8",
                            textColor: "white",
                            borderColor: "#23c6c8",
                            eventType: "otherEvents",
                            eventName: (typeof (calendarRange.title) !== "undefined" ? calendarRange.title : ""),
                            events_notes: calendarRange.events_notes,
                            events_guests: calendarRange.events_guests
                        });
                       
                    });
                    calendar.refetchEvents();
                });
            } else {
                calendar.refetchEvents();
            }
        }

        if ($scope.calendarGroups.indexOf('EVENT-PROGRAM-ACTS') >= 0) {
            if ($scope.checkEventProgramActs) {

                options.event_id = $scope.optionsUsers.event_id;
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/CalendarsEvents/EventProgramActs',
                    params: options
                }).then(function (results, status, headers, config) {       

                    angular.forEach(results.data.rows, function (calendarRange) {

                        var strTitle = $("<div>" + calendarRange.title + "</div>").text();

                        $scope.events.push({
                            task_id: calendarRange.task_id,
                            event_id: calendarRange.event_id,
                            program_act_id: calendarRange.program_act_id,
                            title: strTitle,
                            //start: new Date(moment.utc(calendarRange.date_from)),
                            //end: new Date(moment.utc(calendarRange.date_to)),
                            start: new Date(calendarRange.date_from),
                            end: calendarRange.all_day ? moment(new Date(calendarRange.date_to).setDate(new Date(calendarRange.date_to).getDate() + 1)) : new Date(calendarRange.date_to),
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#23c6c8",
                            textColor: "white",
                            borderColor: "#23c6c8",
                            eventType: "eventProgramAct",
                            eventName:  calendarRange.event_name

                        });

                    });

                    calendar.refetchEvents();

                });
            } else {

                calendar.refetchEvents();

            }
        }

        if ($scope.calendarGroups.indexOf('BIRTHDAYS') >= 0) {
            if ($scope.checkBirthdays) {
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/CalendarsEvents/Birthdays',
                    params: options
                }).then(function (results, status, headers, config) {                        
                    angular.forEach(results.data.rows, function (calendarRange) {
                        var date = moment.utc(new Date(calendarRange.date_from)).toDate();
                        if ((start._d.getMonth() <= end._d.getMonth()) || (start._d.getMonth() > end._d.getMonth() && date.getMonth() >= start._d.getMonth())) {
                            date.setFullYear(start._d.getFullYear());
                        } else
                            date.setFullYear(end._d.getFullYear());

                        var strTitle = $("<div>" + calendarRange.title + "</div>").text();
                        $scope.events.push({
                            title: strTitle,
                            start: date,
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#0D2B7E",
                            textColor: "white",
                            borderColor: "#0D2B7E",
                            eventType: "birthday",
                            person_id: calendarRange.person_id,
                            person_type: calendarRange.person_type,
                            icon: "fa fa-birthday-cake",
                        });

                    });
                    calendar.refetchEvents();
                });
            } else {
                calendar.refetchEvents();
            }
        }

        if ($scope.calendarGroups.indexOf('EVENT-PROGRAM-ACTS-USERS') >= 0) {
            if ($scope.checkActs) {
                //options.user_id = localStorage.getItem("userId");
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/CalendarsEvents/EventProgramActsUser',
                    params: options
                }).then(function (results, status, headers, config) {
                    angular.forEach(results.data.rows, function (calendarRange) {

                        var date = moment.utc(new Date(calendarRange.date_from)).toDate();
                        if ((start._d.getMonth() <= end._d.getMonth()) || (start._d.getMonth() > end._d.getMonth() && date.getMonth() >= start._d.getMonth())) {
                            date.setFullYear(start._d.getFullYear());
                        } else
                            date.setFullYear(end._d.getFullYear());
                        var strTitle = $("<div>" + calendarRange.title + "</div>").text();
                        $scope.events.push({
                            start: moment.utc(calendarRange.date_from).toDate(),
                            end: moment.utc(calendarRange.date_to).toDate(),
                            title: strTitle,
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#0D2B7E",
                            textColor: "white",
                            borderColor: "#0D2B7E",
                            eventType: "acts",
                            person_id: calendarRange.person_id,
                            person_type: calendarRange.person_type,
                            eventName: calendarRange.event_name,
                            icon: "fa fa-clipboard-list",
                        });

                    })
                    calendar.refetchEvents();
                });
            } else {
                calendar.refetchEvents();
            }
        }

        if ($scope.calendarGroups.indexOf('LOCATION_PENDING') >= 0) {
            if ($scope.checkLocationPending) {
                var op = angular.copy(options);
                op.status = "pending";
                op.location_id = $scope.optionsUsers.location_id;
                op.dateFrom1 = op.start;
                op.dateTo2 = op.end;
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/LocationsReservations',
                    params: op
                }).then(function (results, status, headers, config) {
                    angular.forEach(results.data.rows, function (calendarRange) {
                        var date = moment.utc(new Date(calendarRange.date_from)).toDate();
                        if ((start._d.getMonth() <= end._d.getMonth()) || (start._d.getMonth() > end._d.getMonth() && date.getMonth() >= start._d.getMonth())) {
                            date.setFullYear(start._d.getFullYear());
                        } else
                            date.setFullYear(end._d.getFullYear());
                        var strTitle = $("<div>" + calendarRange.notes + "</div>").text();
                        $scope.events.push({
                            id: calendarRange.id,
                            end: moment.utc(calendarRange.date_to).toDate(),
                            title: strTitle,
                            start: date,
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#f8ac59",
                            textColor: "white",
                            borderColor: "#f8ac59",
                            eventType: "locations",
                            person_id: calendarRange.person_id,
                            person_type: calendarRange.person_type,
                            icon: "fa fa-clipboard-list",
                        });
                    });
                    calendar.refetchEvents();
                });
                calendar.refetchEvents();
            }
        }

        if ($scope.calendarGroups.indexOf('LOCATION_CONFIRMED') >= 0) {
            if ($scope.checkLocationConfirmed) {
                options.status = "confirmed";
                options.location_id = $scope.optionsUsers.location_id;
                options.dateFrom1 = options.start;
                options.dateTo2 = options.end;
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/LocationsReservations',
                    params: options
                }).then(function (results, status, headers, config) {
                    angular.forEach(results.data.rows, function (calendarRange) {
                        var date = moment.utc(new Date(calendarRange.date_from)).toDate();
                        if ((start._d.getMonth() <= end._d.getMonth()) || (start._d.getMonth() > end._d.getMonth() && date.getMonth() >= start._d.getMonth())) {
                            date.setFullYear(start._d.getFullYear());
                        } else
                            date.setFullYear(end._d.getFullYear());
                        var strTitle = $("<div>" + calendarRange.notes + "</div>").text();
                        $scope.events.push({
                            id: calendarRange.id,
                            end: moment.utc(calendarRange.date_to).toDate(),
                            title: strTitle,
                            start: date,
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#1ab394",
                            textColor: "white",
                            borderColor: "#1ab394",
                            eventType: "locations",
                            person_id: calendarRange.person_id,
                            person_type: calendarRange.person_type,
                            icon: "fa fa-clipboard-list",
                        });
                    })
                    calendar.refetchEvents();
                });
            } else {
                calendar.refetchEvents();
            }
        }

        if ($scope.calendarGroups.indexOf('LOCATION_REJECTED') >= 0) {
            if ($scope.checkLocationRejected) {
                var op2 = angular.copy(options);
                op2.status = "rejected";
                op2.location_id = $scope.optionsUsers.location_id;
                op2.dateFrom1 = op.start;
                op2.dateTo2 = op.end;
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/LocationsReservations',
                    params: op2
                }).then(function (results, status, headers, config) {
                    angular.forEach(results.data.rows, function (calendarRange) {
                        let date = moment.utc(new Date(calendarRange.date_from)).toDate();
                        if ((start._d.getMonth() <= end._d.getMonth()) || (start._d.getMonth() > end._d.getMonth() && date.getMonth() >= start._d.getMonth())) {
                            date.setFullYear(start._d.getFullYear());
                        } else
                            date.setFullYear(end._d.getFullYear());
                        let strTitle = $("<div>" + calendarRange.notes + "</div>").text();
                        $scope.events.push({
                            id: calendarRange.id,
                            end: moment.utc(calendarRange.date_to).toDate(),
                            title: strTitle,
                            start: date,
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#ed5565",
                            textColor: "white",
                            borderColor: "#ed5565",
                            eventType: "locations",
                            person_id: calendarRange.person_id,
                            person_type: calendarRange.person_type,
                            icon: "fa fa-clipboard-list",
                        });
                    });
                    calendar.refetchEvents();
                });
            } else {
                calendar.refetchEvents();
            }
        }

        if ($scope.calendarGroups.indexOf('LOCATION_CANCELLED') >= 0) {
            if ($scope.checkLocationRejected) {
                var op3 = angular.copy(options);
                op3.status = "cancelled";
                op3.location_id = $scope.optionsUsers.location_id;
                op3.dateFrom1 = op.start;
                op3.dateTo2 = op.end;
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + '/LocationsReservations',
                    params: op3
                }).then(function (results, status, headers, config) {
                    angular.forEach(results.data.rows, function (calendarRange) {
                        var date = moment.utc(new Date(calendarRange.date_from)).toDate();
                        if ((start._d.getMonth() <= end._d.getMonth()) || (start._d.getMonth() > end._d.getMonth() && date.getMonth() >= start._d.getMonth())) {
                            date.setFullYear(start._d.getFullYear());
                        } else
                            date.setFullYear(end._d.getFullYear());
                        var strTitle = $("<div>" + calendarRange.notes + "</div>").text();
                        $scope.events.push({
                            id: calendarRange.id,
                            start: moment.utc(calendarRange.date_from).toDate(),
                            end: moment.utc(calendarRange.date_to).toDate(),
                            title: strTitle,
                            allDay: calendarRange.all_day ? true : false,
                            backgroundColor: "#ed5565",
                            textColor: "white",
                            borderColor: "#ed5565",
                            eventType: "locations",
                            person_id: calendarRange.person_id,
                            person_type: calendarRange.person_type,
                            icon: "fa fa-clipboard-list",
                        });
                    })
                    calendar.refetchEvents();
                });
            } else {
                calendar.refetchEvents();
            }
        }

        if ($scope.calendarGroups.indexOf('LOCATIONS') >= 0) {

            Restangular.all('Locations').getList(options).then(function (result) {
                $scope.locations = result;
                angular.forEach($scope.checkLocationsChecked, function (row,index) {                    
                    if (row.checked) {
                        if (index != null) {
                            var op2 = angular.copy(options);
                            op2.location_group_id = index;
                            op2.dateFrom1 = op2.start;
                            op2.dateTo2 = op2.end;
                            $http({
                                method: 'get',
                                url: (window as any).CONFIG.api_url + '/LocationsReservations',
                                params: op2
                            }).then(function (results, status, headers, config) {
                                angular.forEach(results.data.rows, function (calendarRange) {
                                    var date = moment.utc(calendarRange.date_from).toDate();
                                    /*if ((start._d.getMonth() <= end._d.getMonth()) || (start._d.getMonth() > end._d.getMonth() && date.getMonth() >= start._d.getMonth())) {
                                        date.setFullYear(start._d.getFullYear());
                                    } else {
                                        date.setFullYear(end._d.getFullYear());
                                    }*/
                                    var strTitle = $("<div>" + calendarRange.name + "</div>").text();

                                    $scope.events.push({
                                        id: calendarRange.id,
                                        end: moment.utc(calendarRange.date_to).toDate(),
                                        title: strTitle,
                                        start: date,
                                        allDay: calendarRange.all_day ? true : false,
                                        backgroundColor: calendarRange.FK_locations_reservations_locations.color,
                                        textColor: "white",
                                        borderColor: calendarRange.FK_locations_reservations_locations.color,
                                        eventType: "locations",
                                        reserved_by: calendarRange.reserved_by,
                                        requested_by: calendarRange.FK_locations_reservations_requested_by != null ? calendarRange.FK_locations_reservations_requested_by.name : null,
                                        total_guests: calendarRange.total_guests,
                                        icon: "fa fa-clipboard-list",
                                    });
                                });
                                calendar.refetchEvents();
                            });
                        } else {
                            calendar.refetchEvents();
                        }
                    } else {
                        calendar.refetchEvents();
                    }
                });
            });
        }

    };

    //guardamos estado de check y refrescamos eventos
    $scope.saveCheckAndRefesh = function(checkName, checkValue){
        localStorage.setItem(checkName, checkValue);
        setTimeout(function(){
            $scope[checkName] = checkValue;
            var view = ($("#calendar") as any).fullCalendar("getView");
            $scope.getCalendarEvents(view);
        });
    }

    $scope.refetchEvents = function () {
        ($("#calendar") as any).fullCalendar('refetchEvents');
    };

    $scope.newElement = function (date) {
        let $modalInstance = $uibModal.open({
            animation: true,
            template: NewEventModalView,
            size: "sm",
            controller: "NewEventModalCtrl",
            resolve: {
                date: function () {
                    return date;
                }
            }
        });
        //Response del modal
        $modalInstance.result.then(function () {
            $scope.refetchEvents();                
        }, function () {
            console.info('Modal dismissed at: ' + new Date());
            if (!$scope.$$phase) $scope.$apply();
        });

    };
    
    let language = "ES";

    $scope.uiConfig = {
        calendar: {                
            height: 700,
            editable: false,
            firstDay: 1,
            locales: allLocales,
            locale: language.toLowerCase(),
            selectable: true,
            scrollTime: "08:00:00",
            defaultView: (currentState === "locations.edit" ? "agendaWeek" : "month"),
            header: {
                left: 'month,agendaWeek,agendaDay,listWeek',
                center: 'title',
                right: 'today prev,next'
            },
            events: function (start, end, timezone, callback) {
                ($("#calendar") as any).fullCalendar('removeEvents');
                callback($scope.events);
            },
            eventDurationEditable: false,     
            select: function (startDate, endDate) {
                if (currentState === "locations.edit") $scope.newLocationReservation(null, startDate.format('YYYY-MM-DD HH:mm'), endDate.format('YYYY-MM-DD HH:mm'));
            },
            eventLimit: true, // for all non-agenda views
            views: {
                month: {
                    eventLimit: 3 // adjust to 6 only for agendaWeek/agendaDay
                }
            },
            dayClick: function (date, jsEvent, view, resourceObj) {
                if (currentState !== "locations.edit") $scope.newElement(new Date(new Date(date).setHours(0, 0, 0, 0)));
            },
            eventRender: function (calEvent, element) {

                var content = "";
                if (angular.isDefined(calEvent.event_id) && calEvent.event_id != null && calEvent.event_id != "null") {
                    content += '<b>' + $filter('translate')('calendars.event') + ':</b> ' + calEvent.eventName;
                }
                if (angular.isDefined(calEvent.entityType) && calEvent.entityType != "") {
                    let entityTranslate = "";
                    if (calEvent.entityType == "general") {
                        entityTranslate = $filter('translate')('entity_types.general');
                    } else if (calEvent.entityType == "correspondence") {
                        entityTranslate = $filter('translate')('correspondence.title');
                    }
                    content += '<b>' + $filter('translate')('calendars.entityType') + ':</b> ' + entityTranslate;
                }
                if (calEvent.eventType === "birthday") {
                    content += '<div><b>' + $filter('translate')('events.programs_acts.date') + ':</b> ';
                    if (calEvent.start != null) content += calEvent.start.format("DD/MM/YYYY") + " ";
                    if (!calEvent.allDay) content += calEvent.start.format("HH:mm");
                    content += '<br>';
                    content += '<br><div style="text-align: center;"><a class="btn btn-xs btn-white" ui-sref="persons.edit({person_type: \'' + calEvent.person_type + '\',id:' + calEvent.person_id + '})"><i class="fa fa-pencil"></i> ' + $filter('translate')('calendars.see_profile') + '</a></div></div>';
                    if (calEvent.icon) {
                        element.find(".fc-title").prepend("<i class='" + calEvent.icon + "'></i> ");
                    }
                } else {
                    content += '<div><b>' + $filter('translate')('calendars.from') + ':</b> ';
                    if (calEvent.start !== null) content += calEvent.start.format("DD/MM/YYYY") + " ";
                    if (!calEvent.allDay) content += calEvent.start.format("HH:mm");
                    content += '<br>';
                    content += '<b>' + $filter('translate')('calendars.to') + ":</b> ";
                    if (calEvent.end !== null) {
                        //formateamos bien la información en el caso de que sea allDay
                        if (calEvent.allDay) {
                            var dateFormatedLessOne = moment(new Date(calEvent.end).setDate(new Date(calEvent.end).getDate() - 1));
                            content += dateFormatedLessOne.format("DD/MM/YYYY") + " ";
                        } else {
                            content += calEvent.end.format("DD/MM/YYYY") + " ";
                        }
                        
                    } else {
                        content += calEvent.start.format("DD/MM/YYYY") + " ";
                    }
                    if (typeof (calEvent.events_guests) == "undefined" || calEvent.events_guests == null) calEvent.events_guests = 0;
                    if (calEvent.end !== null && !calEvent.allDay) content += calEvent.end.format("HH:mm");
                    content += '<br>';
                    if (calEvent.eventType === "UserTasks" || calEvent.eventType == "EventTasks" || calEvent.eventType == "OtherTasks") {
                        logService.debug(calEvent);
                        content += '<br><div ng-controller="EventsTasksListCtrl" style="text-align: center;"><a class="btn btn-xs btn-white" ng-click="addEventTask(' + calEvent.task_id + ')"><i class="fa fa-pencil"></i> ' + $filter('translate')('calendars.seeTask') + '</a>';
                        if (calEvent.event_id) content += '<a class="btn btn-xs btn-white m-l" href="#" ui-sref="events.edit({id: ' + calEvent.event_id + ' })" > <i class="fa fa-eye"></i> ' + $filter('translate')('calendars.seeEvent') + '</a>'; 
                        content += '</div ></div > ';
                    }
                    if (calEvent.eventType === "UserTasksNew") {
                        content += '<br><div style="text-align: center;"><a class="btn btn-xs btn-white" ng-click="addTask(' + calEvent.task_id + ', ' + calEvent.entityType + ', ' + calEvent.entityTypeId + ')"><i class="fa fa-pencil"></i> ' + $filter('translate')('calendars.seeTask') + '</a>';
                    }

                    if (calEvent.eventType === "Events" || calEvent.eventType == "otherEvents" || calEvent.eventType == "userEvents") {
                        let notes = "";
                        if (calEvent.events_notes != null) notes = calEvent.events_notes.replace("\n", "<br>");
                        content += '<br><div>' + (calEvent.events_notes != null ? notes + '<br><b>' : "<b>") + $filter('translate')('calendars.num_guests') + ':</b> ' + calEvent.events_guests + '<br><br><div style="text-align: center;"><a class="btn btn-xs btn-white" href="#" ui-sref="events.edit({id: ' + calEvent.event_id + ' })" > <i class="fa fa-pencil"></i> ' + $filter('translate')('calendars.seeEvent') + '</a></div></div> ';
                    }
                    //si lo descomento, falla porque no inyecta event
                    if (calEvent.eventType === "eventProgramAct") content += '<br><div ng-controller="EventsProgramsActsListCtrl" style="text-align: center;"><a class="btn btn-xs btn-white" ng-click="addEventProgramAct(' + calEvent.task_id + ')"><i class="fa fa-pencil"></i> ' + $filter('translate')('calendars.seeProgramAct') + '</a></div></div>';
                    if (calEvent.eventType === "locations") {
                        content += '<br><div>' + $filter('translate')('locations_reservations.reserved_by') + ': ' + (calEvent.reserved_by != null ? calEvent.reserved_by: '');
                        content += '<br>' + $filter('translate')('locations_reservations.requested_by') + ': ' + (calEvent.requested_by != null?calEvent.requested_by: '');
                        content += '<br>' + $filter('translate')('calendars.num_guests') + ': ' + calEvent.total_guests + '</div>';
                        content += '<br><div style="text-align: center;"><a class="btn btn-xs btn-white" ui-sref="locations_reservations.edit({id: ' + calEvent.id + '})"><i class="fa fa-pencil"></i> ' + $filter('translate')('calendars.seeFullLocationReservation') + '</a></div><div style = "text-align: center;" > <a class="btn btn-xs btn-white" ng-click="newLocationReservation(' + calEvent.id + ', '+calEvent.start + ',' + calEvent.end + ')"><i class="fa fa-pencil"></i> ' + $filter('translate')('calendars.seeLocationReservation') + '</a></div>';
                    }
                } 
                element.find('.fc-event-dot').css({ 'border': '1px solid ' + calEvent.borderColor }); //borde enlos puntos de la lista para que al imprimir se vea bien.
                var contentCompiled = $compile(content)($scope);

                //@ts-ignore
                $(element).popover({
                    html: true,
                    title: calEvent.title.replace('>', '').replace('>', ''),
                    content: contentCompiled,
                    placement: 'top',
                    container: '#calendar',
                    trigger: "click"
                });
                   

            },                
            viewRender: function (view, element) {
                //Actualizamos las opciones de inicio y fin para que sólo pinte el intervalo lo que estamos visualizando
                $scope.optionsUsers.start = view.start;
                $scope.optionsUsers.end = view.end;
                setTimeout(function(){
                    $scope.getCalendarEvents(view);
                }, 300);
            }
        }
    };

    $scope.addTask = function (id, entity_type, entity_type_id) {

        let $modalInstance = $uibModal.open({
            animation: true,
            template: TaskModalView,
            controller: "TaskModalCtrl",
            size: 'lg',
            resolve: {
                task_id: function () {
                    return id;
                },
                entity_type: function () {
                    return entity_type;
                },
                entity_type_id: function () {
                    return entity_type_id;
                },
                type: function () {
                    return "task";
                }
            }

        });

        //Retorno de los datos desde el modal.
        $modalInstance.result.then(function (resultModal) { 
            if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();
        }, function () {
            console.info('Modal dismissed at: ' + new Date());
            //  $scope.identity = {};
        });

    };


    $scope.printDialog = function (code, type_document, type_result, id) {
        if (!angular.isDefined(type_document)) type_document = "pdf";
        if (!angular.isDefined(type_result)) type_result = "list";
        if (!angular.isDefined(id)) id = "";
        var event_id = null;

        var codes = "";
        if ($scope.checkUserTasks) codes += (codes !== "" ? "," + "USER-TASKS" : "USER-TASKS");
        if ($scope.checkOtherTasks) codes += (codes !== "" ? "," + "OTHER-TASKS" : "OTHER-TASKS");
        if ($scope.checkEventTasks) codes += (codes !== "" ? "," + "EVENT-TASKS" : "EVENT-TASKS");
        if ($scope.checkEvents) codes += (codes !== "" ? "," + "EVENTS" : "EVENTS");
        if ($scope.checkUserEvents) codes += (codes !== "" ? "," + "USER-EVENTS" : "USER-EVENTS");
        if ($scope.checkOtherEvents) codes += (codes !== "" ? "," + "OTHER-EVENTS" : "OTHER-EVENTS");
        if ($scope.checkEventProgramActs) codes += (codes !== "" ? "," + "EVENT-PROGRAM-ACTS" : "EVENT-PROGRAM-ACTS");
        if ($scope.checkBirthdays) codes += (codes !== "" ? "," + "BIRTHDAYS" : "BIRTHDAYS");
        if ($scope.checkActs) codes += (codes !== "" ? "," + "EVENT-PROGRAM-ACTS-USERS" : "EVENT-PROGRAM-ACTS-USERS");

        if ($state.current.name !== 'dashboard.list') {
            event_id = $stateParams.id;
        }
        logService.debug(codes);
        var params = {
            entity_type: ($state.current.name !== 'dashboard.list' ? "events" : "schedule"),
            entity_type_id: ($state.current.name !== 'dashboard.list' ? $stateParams.id : null),
            documents: { codes: ["CALENDAR"] }
        };
        generateDocumentService.documentNew({
            params: params,
            onAccept: function (data) {
                angular.forEach(data, function (item) {
                    $http({
                        method: 'post',
                        url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                        params: { document_id: item.document_id, event_id: null, user_id: $scope.optionsUsers.user_id, start_date: $scope.optionsUsers.start.format('YYYY-MM-DD'), end_date: $scope.optionsUsers.end.format('YYYY-MM-DD'), codes: codes, outputType: 'pdf' }
                    }).then(function (result, status, headers, config) {
                        var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                        window.open(url, '_blank');
                    });
                })
            }
        });
    };

    $scope.newLocationReservation = function (id, startDate, endDate) {
        $('.popover').hide();
        let $modalInstance = $uibModal.open({
            animation: true,
            template: NewReservationModalView,
            controller: "NewReservationModalCtrl",
            size: 'lg',
            resolve: {
                id: function () {
                    return id;
                },
                startDate: function () {
                    return startDate;
                }, endDate: function () {
                    return endDate;
                },
                location_id: function () {
                    return $stateParams.id;
                }
            }
        });

        $modalInstance.result.then(function () {
            $scope.refetchEvents();
        }, function () {
            console.info('Modal dismissed at: ' + new Date());
            if (!$scope.$$phase) $scope.$apply();
        });
    };

    $(function () {
        ($("#calendar") as any).fullCalendar('render');
        $('body').on('click', function (e) {
                
            if ($(e.target).parents(".uib-daypicker").length > 0 && ($(e.target).hasClass("uib-left") || $(e.target).parents(".uib-left").length > 0)) {
                $scope.selectDate(moment($scope.dt).add(-1, 'month').toDate());
            } else if ($(e.target).parents(".uib-daypicker").length > 0 && ($(e.target).hasClass("uib-right") || $(e.target).parents(".uib-right").length > 0)) {
                $scope.selectDate(moment($scope.dt).add(1, 'month').toDate());
            } else if ($(e.target).parents(".uib-monthpicker").length > 0 && ($(e.target).hasClass("uib-left") || $(e.target).parents(".uib-left").length > 0)) {
                $scope.selectDate(moment($scope.dt).add(-1, 'year').toDate());
            } else if ($(e.target).parents(".uib-monthpicker").length > 0 && ($(e.target).hasClass("uib-right") || $(e.target).parents(".uib-right").length > 0)) {
                $scope.selectDate(moment($scope.dt).add(1, 'year').toDate());
            } else if ($(e.target).parents(".uib-yearpicker").length > 0 && ($(e.target).hasClass("uib-left") || $(e.target).parents(".uib-left").length > 0)) {
                $scope.selectDate(moment($scope.dt).add(-20, 'year').toDate());
            } else if ($(e.target).parents(".uib-yearpicker").length > 0 && ($(e.target).hasClass("uib-right") || $(e.target).parents(".uib-right").length > 0)) {
                $scope.selectDate(moment($scope.dt).add(20, 'year').toDate());
            } else if (($(e.target).parents(".fc-event").length == 0 && $(e.target).parents(".popover").length == 0) && $(e.target).parents(".fc-listWeek-view").length == 0) {
                $('.popover').hide();
            }
        });

    });

    $scope.downloadICA = function () {
        var url = null;

        if ($scope.calendarGroups.indexOf('LOCATIONS') >= 0) {
            url = $scope.base_url_api + "CalendarsEvents/GenerateIcaLocations";
        } else {
            let formatToken = "user_id:" + localStorage.getItem("userId") + "|checkUserEvents:" + localStorage.getItem("checkUserEvents")
                + "|checkOtherEvents:" + localStorage.getItem("checkOtherEvents")
                + "|checkUserTasks:" + localStorage.getItem("checkUserTasks")
                + "|checkOtherTasks:" + localStorage.getItem("checkOtherTasks")
                + "|checkActs:" + localStorage.getItem("checkActs")
                + "|checkBirthdays:" + localStorage.getItem("checkBirthdays");
            var token = btoa(formatToken);
            url = $scope.base_url_api + "CalendarsEvents/GenerateIca?token=" + token;
        }

        var translateText = $filter('translate')('calendar.text_to_copy_ica');
        //"Copia el siguiente enlace y utilizado para añadir un calendario desde internet en tu outlook:\n"
        prompt(translateText, url);

        //window.open(CONFIG.api_url + 'CalendarsEvents/GenerateIca?token=' + token, '_blank', '');
    };

}])

    .controller("NewEventModalCtrl", ['$rootScope', '$state', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', '$uibModal', 'date', function ($rootScope, $state, LoginService,$scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, $uibModal, date) {

    $scope.date = date;

    Restangular.all('EventsTypes').getList().then(function (eventsTypes) {
        $scope.selectEventsTypes = eventsTypes;
    });

    $scope.newEvent = function (type) {

        if (type === 'task') {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: TaskModalView,
                controller: "CalendarTaskModalCtrl",
                size: 'lg',
                resolve: {
                    date: function () {
                        return $scope.date;
                    }
                }
            });

            $modalInstance.result.then(function () {
                $uibModalInstance.close();
            }, function () {
                console.info('Modal dismissed at: ' + new Date());
                if (!$scope.$$phase) $scope.$apply();
            });
        }

        if (type === 'event') {
            Restangular.all('Events').getList({ is_template: true }).then(function (templates) {
                templates.unshift({
                    id: undefined,
                    name: $filter('translate')('events.no_template')
                })
                $scope.templates = templates;

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: TemplateModalView,
                    size: "lg",
                    controller: "TemplateModalCtrl",
                    resolve: {
                        templates: function () { return $scope.templates; }
                    }
                });
                //Response del modal
                $modalInstance.result.then(function (id) {
                    $uibModalInstance.close();
                    $rootScope.newEvent = {
                        date: $scope.date
                    };
                    $state.go("events.edit", { id: id, is_template: false });
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });
            });

        }

    };

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

}])

.controller("CalendarTaskModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'date', 'uiSliderConfig', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, date, uiSliderConfig) {

    //Comprobamos si tiene permiso escritura
    $scope.allowWrite = LoginService.permissionExist("EVENTS_TASKS_WRITE");

    $scope.eventTask = {};
    $scope.selectedUsersIdS = [];        
    $scope.borderRight = { "border-right": "none" };

    $scope.eventTask.date_from = new Date(date);
    $scope.eventTask.date_to = new Date(date);

    $scope.is_template = $stateParams.is_template == 'true';
        
    $scope.eventTask.all_day = true;
    if (!$scope.is_template) {
        $scope.eventTask.work_progress = 0;
    }
    $scope.eventTask.event_task_id = 0;

    Restangular.all('Users').getList().then(function (results) {
        $scope.selectUsers = results;
    });

    Restangular.all('Events').getList().then(function (results) {
        $scope.selectEvents = results;
    });


    $scope.eventChanged = function (event_id) {
        let params = {
            event_id: event_id,
            is_group: true
        };
        Restangular.all('EventsTasks').getList(params).then(function (results) {
            $scope.selectEventTaskGroups = results;
            var withoutGroup = {
                id: 0,
                title: $filter('translate')('events.tasks.without_group'),
                is_group: true
            };
            $scope.selectEventTaskGroups.unshift(withoutGroup);
        });
    };
        
    $scope.selectEventTaskGroups = [];
    var withoutGroup = {
        id: 0,
        title: $filter('translate')('events.tasks.without_group'),
        is_group: true
    };            
    $scope.selectEventTaskGroups.unshift(withoutGroup);        
    
    

    Restangular.all('TasksTypes').getList({ entity_type: "events" }).then(function (results) {
        $scope.selectTaskTypes = results;
    });

    
    Restangular.all('TasksStatus').getList({entity_type: "events"}).then(function (results) {
        $scope.selectTaskStatus = results;
        if (angular.isUndefined($scope.eventTask.id)) {
            $scope.eventTask.FK_events_tasks_tasks_status = $scope.selectTaskStatus[0];
        }
    });

    $scope.saveEventTask = function () {
        if ($scope.eventTask.event_task_id == 0) $scope.eventTask.event_task_id = null;
        $scope.eventTask.FK_events_tasks_users_events_tasks = [];

        $scope.eventTask.task_type_id = $scope.eventTask.FK_events_tasks_tasks_types.id;
        $scope.eventTask.task_status_id = $scope.eventTask.FK_events_tasks_tasks_status.id;
        angular.forEach($scope.eventTask.selected_users, function (user) {
            $scope.eventTask.FK_events_tasks_users_events_tasks.push({
                event_task_id: $scope.eventTask.id,
                user_id: user.id
            });
        });

        Restangular.all('eventsTasks').post($scope.eventTask).then(function (result) {
            if (typeof (result.id) !== "undefined") {
                $uibModalInstance.close();
                toastr.success($filter('translate')('events.tasks.add_success'));
            } else {
                $scope.errorMessage = result.message;
            }
        });

    };

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };        
    
}])

.controller("CalendarEventModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'date', 'uiSliderConfig', '$rootScope', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, date, uiSliderConfig, $rootScope) {

    //Comprobamos si tiene permiso escritura
    $scope.allowWrite = LoginService.permissionExist("EVENTS_WRITE");

    Restangular.all('EventsTypes').getList().then(function (eventsTypes) {
        $scope.selectEventsTypes = eventsTypes;
    });

    $scope.event = {};   
    $scope.is_template = $stateParams.is_template == 'true';
    $scope.event.date_from = date;
    $scope.event.date_to = date;


    $scope.event.all_day = true;

    Restangular.all('Users').getList().then(function (users) {
        $scope.selectUsers = users;
    });
    
    $scope.saveEvent = function () {
        $scope.event.is_template = $scope.is_template;
        if ($rootScope.isDefinedAndNotNullAndNotEmpty($scope.event.FK_events_users)) $scope.event.responsible_id = $scope.event.FK_events_users.id;
        if ($scope.event.date_to != null && $scope.event.date_to < $scope.event.date_from) $scope.event.date_to = $scope.event.date_from;
        
        Restangular.all('Events').post($scope.event).then(function (result) {
            if (typeof (result.id) != "undefined") {
                $uibModalInstance.close();
                toastr.success($filter('translate')('events.tasks.add_success'));
            } else {
                $scope.errorMessage = result.message;
            }
        });
    };

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };


}])

.controller("NewReservationModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', 'startDate', 'endDate', 'id', 'location_id', function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, startDate, endDate, id, location_id) {

    //Comprobamos si tiene permiso escritura
    $scope.allowWrite = LoginService.permissionExist("EVENTS_WRITE");
    $scope.selectStatus = [{
        code: 'pending', name: $filter('translate')('locations_reservations.status_pending')
    }, {
        code: 'confirmed', name: $filter('translate')('locations_reservations.status_confirmed')
    }, {
        code: 'cancelled', name: $filter('translate')('locations_reservations.status_cancelled')
    }, {
        code: 'rejected', name: $filter('translate')('locations_reservations.status_rejected')
    }];

    if (typeof (id) !== 'undefined' && id != null) {
        Restangular.one('LocationsReservations', id).get().then(function (results) {
            $scope.location_reservation = results;
            $scope.location_reservation.date_from = new Date($scope.location_reservation.date_from);
            $scope.location_reservation.date_to = new Date($scope.location_reservation.date_to);
            angular.forEach($scope.selectStatus, function (status) {
                if ($scope.location_reservation.status == status.code) $scope.location_reservation.status = status;
            });
        });    

    } else {
        $scope.location_reservation = {};
        $scope.location_reservation.date_from = new Date(startDate);
        $scope.location_reservation.date_to = new Date(endDate);
        $scope.location_reservation.location_id = location_id;
        $scope.location_reservation.status = $scope.selectStatus[0];
    }
       
       
    $scope.save = function (frmLocationReservation) {
        $scope.location_reservation.status = $scope.location_reservation.status.code;
        if (!angular.isUndefined($scope.location_reservation.id)) {
            $scope.location_reservation.put().then(function (result) {
                if (angular.isDefined(result.id)) {
                    toastr.success($filter('translate')('locations_reservations.edit_success'));
                    $uibModalInstance.close();
                } else {
                    $scope.errorMessage = result.message;
                }
            });
        } else {
            Restangular.all('LocationsReservations').post($scope.location_reservation).then(function (result) {
                if (angular.isDefined(result.id)) {
                    toastr.success($filter('translate')('locations_reservations.create_success'));
                    $uibModalInstance.close();
                } else {
                    $scope.errorMessage = result.message;
                }
            });
        }
    };

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.deleteDialog = function (id, location_name) {
        $scope.id = id;
        $scope.location_name = location_name;
        modalService.confirm({
            title: $filter('translate')('locations_reservations.button_delete'),
            message: $filter('translate')('locations_reservations.delete_message') + " " + $scope.location_name + "?",
            onAccept: function () {
                Restangular.one('LocationsReservations', $scope.id).remove().then(function () {
                    toastr.success($filter('translate')('locations_reservations.delete_success'));
                    $uibModalInstance.close();
                }, function (response) {
                    $scope.errorMessage = response.message;
                });
            }
        });
    };

}])
;

